import styled from 'styled-components'
import { pxToRem } from '../../utils'

const FormControl = styled.div`
  padding: ${pxToRem(8)};
  span {
    position: absolute;
  }
`

export default FormControl



// WEBPACK FOOTER //
// ./src/components/Form/FormControl.js